//
import {
  Badge,
  Box,
  Button,
  Checkbox,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Select,
  Textarea,
  useDisclosure,
  ModalFooter,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Portal
} from "@chakra-ui/react";
import { BiTable, BiCard } from "react-icons/bi";
import {
  MdOutlineRefresh,
  MdArrowBack,
  MdEdit,
  MdDeleteOutline,
  MdOutlineVisibility,
  MdContactPhone,
  MdDelete,
  MdAssignmentInd,
  MdMoreVert,
} from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  closeAddLeadsDrawer,
  closeEditLeadsDrawer,
  closeSendSMSDrawer,
  closeShowBulkAssignDrawer,
  closeShowDetailsLeadsDrawer,
  closeShowChatDrawer,
  openAddLeadsDrawer,
  openEditLeadsDrawer,
  openSendSMSDrawer,
  openShowBulkAssignDrawer,
  openShowDetailsLeadsDrawer,
  openShowChatDrawer,
  openKYCDrawer,
  closeKYCDrawer,
  openMoveToDemoDrawer,
  closeMoveToDemoDrawer,
} from "../../redux/reducers/misc";
import { useEffect, useRef, useState, useMemo } from "react";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";
import Loading from "../ui/Loading";
import { FcDatabase } from "react-icons/fc";
import {
  FaArrowsAlt,
  FaCaretDown,
  FaCaretUp,
  FaFileCsv,
  FaSms,
  FaUserShield,
  FaWhatsapp,
  FaCalendarAlt,
} from "react-icons/fa";
import axios from "axios";
import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableContainer,
} from "@chakra-ui/react";
import { usePagination, useSortBy, useTable } from "react-table";
import ClickMenu from "../ui/ClickMenu";
import LeadEditDrawer from "../ui/Drawers/Edit Drawers/LeadEditDrawer";
import LeadsDetailsDrawer from "../ui/Drawers/Details Drawers/LeadsDetailsDrawer";
import Chatdrawer from "../ui/Drawers/Chat/Chatdrawer";
import LeadsDrawer from "../ui/Drawers/Add Drawers/LeadsDrawer";
import KYCDrawer from "../ui/Drawers/KYC/KYCDrawer";
import MoveToDemo from "../ui/Drawers/Edit Drawers/MoveToDemo";
import moment from "moment";

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from "@chakra-ui/react";
import { json, Link, useLocation } from "react-router-dom";
import { checkAccess } from "../../utils/checkAccess";
import { IoLogoWhatsapp } from "react-icons/io";
import sampleCSV from "../../assets/bulk-upload-sample.csv";
import SMSDrawer from "../ui/Drawers/Add Drawers/SMSDrawer";
import BulkAssignDrawer from "../ui/Drawers/Add Drawers/BulkAssignDrawer";
import PieChart from "../ui/Charts/PieChart";

// columns moved inside component

const Leads = () => {
  const [cookies] = useCookies();
  const [selected, setSelected] = useState([]);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [dataId, setDataId] = useState();
  const [loading, setLoading] = useState(true);
  const [bulkUploading, setBulkUploading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [viewMode, setViewMode] = useState("table");

  const [leadSummaryData, setLeadSummaryData] = useState([]);
  const [leadSummaryLabels, setLeadSummaryLabels] = useState([]);
  const [leadSummaryBG, setLeadSummaryBG] = useState([]);

  const [isAllSelected, setIsAllSelected] = useState(false);

  // canonical list of selected lead ids and handlers must be defined before columns
  const [selectedIds, setSelectedIds] = useState([]); // canonical list of selected lead ids
  const selectOneHandler = (e, id) => {
    if (e.target.checked) {
      setSelectedIds((prev) => {
        const updated = [...prev, id];
        // If all rows on current page are selected, mark header as checked
        const currentPageIds = filteredData
          .slice(pageIndex * pageSize, pageIndex * pageSize + pageSize)
          .map((d) => d._id);
        const allSelected = currentPageIds.every((pid) =>
          updated.includes(pid)
        );
        setIsAllSelected(allSelected);
        return updated;
      });
    } else {
      setSelectedIds((prev) => {
        const updated = prev.filter((pid) => pid !== id);
        setIsAllSelected(false); // unchecking any box resets the header checkbox
        return updated;
      });
    }
  };

  const selectAllHandler = () => {
    const select = !isAllSelected;
    setIsAllSelected(select);

    const currentPageData = filteredData.slice(
      pageIndex * pageSize,
      pageIndex * pageSize + pageSize
    );

    if (select) {
      const ids = currentPageData.map((d) => d._id);
      setSelectedIds((prev) => Array.from(new Set([...prev, ...ids])));
    } else {
      // remove only current page's IDs from selectedIds
      const pageIds = currentPageData.map((d) => d._id);
      setSelectedIds((prev) => prev.filter((id) => !pageIds.includes(id)));
    }
  };

  useEffect(() => {
    if (!selectedIds || selectedIds.length === 0) {
      setSelectedUsers([]);
      setBulkSMSMobiles([]);
      setBulkName([]);
      setDataInfo([]);
      return;
    }

    const selectedRows = filteredData.filter((d) =>
      selectedIds.includes(d._id)
    );

    const users = selectedRows.map((d) => ({
      id: d._id,
      phone: d.phone,
      name: d.name,
    }));
    setSelectedUsers(users);
    setBulkSMSMobiles(selectedRows.map((d) => d.phone));
    setBulkName(selectedRows.map((d) => d.name));
    setDataInfo(selectedRows.map((d) => d._id));
  }, [selectedIds, filteredData]);

  const dispatch = useDispatch();
  const location = useLocation();

  const [leadDeleteId, setLeadDeleteId] = useState();
  const [deleteAll, setDeleteAll] = useState(false);
  const [dataInfo, setDataInfo] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [toggleBulkUpload, setToggleBulkUpload] = useState(false);
  const csvRef = useRef();

  const [bulkSMSMobiles, setBulkSMSMobiles] = useState([]);
  const [components, setComponents] = useState([{ type: "text", text: "" }]);
  const [open, setOpen] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [templateLang, setTemplateLang] = useState();
  const [bulkName, setBulkName] = useState([]);
  const [temData, setTemData] = useState([]);
  const {
    isOpen: isTemplateModalOpen,
    onOpen: openTemplateModal,
    onClose: closeTemplateModal,
  } = useDisclosure();
  const [entityId, setEntityId] = useState("1001558230000012624");

  const [templateId, setTemplateId] = useState("");
  const [templateText, setTemplateText] = useState("");
  const [savingTemplate, setSavingTemplate] = useState(false); // For loading state on save

  // Table columns: hide Created On, Created By, Assigned, Source, Follow-up Date/Reason, PRC QT from main table.
  // Add a View button to open details drawer where these fields are shown.
  const columns = useMemo(
    () => [
      {
        Header: () => (
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={selectAllHandler}
            className="cursor-pointer"
          />
        ),
        accessor: "select",
      },
      { Header: "Type", accessor: "leadtype" },
      { Header: "Name", accessor: "name" },
      { Header: "Lead Category", accessor: "leadCategory" },
      { Header: "Status", accessor: "status" },
      { Header: "Tag", accessor: "tag" },
      { Header: "Phone", accessor: "phone" },
      { Header: "Email", accessor: "email" },
      { Header: "Location", accessor: "location" },
      {
        Header: "View",
        accessor: "view",
        Cell: ({ row }) => (
          <Button
            size="sm"
            onClick={() => {
              setDataId(row.original._id);
              dispatch(openShowDetailsLeadsDrawer());
            }}
          >
            View
          </Button>
        ),
      },
    ],
    [dispatch, isAllSelected]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    state: { pageIndex, pageSize },
    pageCount,
    setPageSize,
  } = useTable(
    {
      columns,
      data: filteredData,
      initialState: { pageSize: 5 },
    },
    useSortBy,
    usePagination
  );

  const {
    addLeadsDrawerIsOpened,
    editLeadsDrawerIsOpened,
    showDetailsLeadsDrawerIsOpened,
    showChatDrawerIsOpened,
    sendSMSDrawerIsOpened,
    showBulkAssignDrawerIsOpened,
    kycDrawerIsOpened,
    moveToDemoDrawerIsOpened,
  } = useSelector((state) => state.misc);

  const { role, ...auth } = useSelector((state) => state.auth);
  const { isAllowed, msg } = checkAccess(auth, "lead");

  const statusStyles = {
    "meeting scheduled": {
      bg: "#e6f4ff",
      text: "#0958d9",
    },
    "meeting completed": {
      bg: "#f6ffed",
      text: "#389e0d",
    },
    "in negotiation": {
      bg: "#f9f0ff",
      text: "#531dab",
    },
    "deal on hold": {
      bg: "#deb887",
      text: "#ffffff",
    },
    "deal won": {
      bg: "#f6ffed",
      text: "#389e0d",
    },
    "deal lost": {
      bg: "#fff1f0",
      text: "#cf1322",
    },
  };

  const sourceStyles = {
    linkedin: {
      bg: "rgb(65, 105, 225)",
      text: "#fff",
    },
    "social media": {
      bg: "rgb(135, 206, 235)",
      text: "#fff",
    },
    website: {
      bg: "rgb(255, 127, 80)",
      text: "#fff",
    },
    advertising: {
      bg: "rgb(0, 100, 0)",
      text: "#fff",
    },
    friend: {
      bg: "rgb(178, 34, 34)",
      text: "#fff",
    },
    "professionals network": {
      bg: "rgb(199, 21, 133)",
      text: "#fff",
    },
    "customer referral": {
      bg: "rgb(238, 130, 238)",
      text: "#fff",
    },
    sales: {
      bg: "rgb(255, 20, 147)",
      text: "#fff",
    },
    "digital marketing": {
      bg: "rgb(255, 20, 147)",
      text: "#fff",
    },
    upwork: {
      bg: "#636e72",
      text: "#fff",
    },
    gem: {
      bg: "#fdcb6e",
      text: "#fff",
    },
    freelancer: {
      bg: "#ff7675",
      text: "#fff",
    },
    indiamart: {
      bg: "#e17055",
      text: "#fff",
    },
    fiverr: {
      bg: "#00b894",
      text: "#fff",
    },
  };

  const baseURL = process.env.REACT_APP_BACKEND_URL;
  const fetchAllLeads = async () => {
    setSearchKey("");
    setData([]);
    setFilteredData([]);
    setLoading(true);
    try {
      const response = await fetch(baseURL + "lead/all-leads", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${cookies?.access_token}`,
        },
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message);
      }

      const newData = data.leads.filter(
        (lead) =>
          lead.dataBank !== true &&
          lead?.status !== "Scheduled Meeting" &&
          lead?.status !== "Completed"
      );

      setData(newData);
      setFilteredData(data.leads); // If you want to filter this too, apply same filter
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
  };

  const fetchLeadSummary = async () => {
    setData([]);
    setFilteredData([]);
    setLoading(true);
    try {
      const response = await fetch(baseURL + "lead/lead-summary", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${cookies?.access_token}`,
        },
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message);
      }

      setLeadSummaryBG([
        "#F57D6A",
        "#F8D76A",
        "#54CA21",
        "#21CAC1",
        "#2170CA",
        "#C439EB",
        "#C7C7C7",
        "#F35C9D",
        "#55DCB8",
      ]);

      const labels = Object.keys(data.leads[0].statusCount).map((status) => {
        return `${status} ${(
          (data.leads[0].statusCount[status] / data.leads[0].totalCount) *
          100
        ).toFixed(2)}%`;
      });

      setLeadSummaryLabels(labels);
      setLeadSummaryData(Object.values(data.leads[0].statusCount));
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
  };

  const bulkUploadHandler = async (e) => {
    e.preventDefault();

    try {
      setBulkUploading(true);
      if (csvRef.current.files.length === 0) {
        toast.error("CSV file not selected");
        return;
      }

      const formData = new FormData();
      formData.append("excel", csvRef.current.files[0]);

      const baseURL = process.env.REACT_APP_BACKEND_URL;

      const response = await fetch(baseURL + "lead/bulk-upload", {
        method: "POST",
        headers: {
          authorization: `Bearer ${cookies?.access_token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message);
      }

      fetchAllLeads();
      setToggleBulkUpload(false);
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setBulkUploading(false);
    }
  };

  const bulkSMSHandler = (e) => {
    const rows = document.getElementsByName("select");
    const selectedRows = Array.from(rows).filter((el) => el.checked);
    if (selectedRows.length === 0) {
      toast.error("No lead selected");
      return;
    }
    const selectedRowIds = selectedRows.map((e) => e.value);
    setSelected(selectedRowIds);

    dispatch(openSendSMSDrawer());
  };

  const [showBulkButtons, setShowBulkButtons] = useState(false);

  const bulkAssignHandler = async (e) => {
    const rows = document.getElementsByName("select");
    const selectedRows = Array.from(rows).filter((e) => e.checked);
    if (selectedRows.length === 0) {
      toast.error("No lead selected");
      return;
    }
    const selectedRowIds = selectedRows.map((e) => e.value);
    setSelected(selectedRowIds);

    dispatch(openShowBulkAssignDrawer());
  };

  const bulkDownloadHandler = async (e) => {
    fetch(baseURL + "lead/bulk-download", {
      method: "GET",
      headers: {
        authorization: `Bearer ${cookies?.access_token}`,
      },
    })
      .then((response) => {
        const filename = response.headers
          .get("content-disposition")
          .split("filename=")[1]
          .replace(/"/g, "");
        return response.blob().then((blob) => ({ filename, blob }));
      })
      .then(({ filename, blob }) => {
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = filename;
        a.click();
        a.remove();
      })
      .catch((err) => {
        toast.error(err?.message || "Something went wrong");
      });
  };

  const addLeadsHandler = () => {
    dispatch(openAddLeadsDrawer());
  };

  const kycHandler = () => {
    dispatch(openKYCDrawer());
  };

  const confirmDeleteHandler = async () => {
    onOpen();
  };

  const deleteAllHandler = async () => {
    try {
      const response = await fetch(baseURL + "lead/delete-all", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${cookies?.access_token}`,
        },
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message);
      }

      onClose();
      fetchAllLeads();
      toast.success(data.message);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const deleteHandler = async () => {
    if (!leadDeleteId) {
      return;
    }

    try {
      const response = await fetch(baseURL + "lead/delete-lead", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${cookies?.access_token}`,
        },
        body: JSON.stringify({
          leadId: leadDeleteId,
        }),
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message);
      }

      onClose();
      fetchAllLeads();
      toast.success(data.message);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const editHandler = (id) => {
    setDataId(id);
    dispatch(openEditLeadsDrawer());
  };

  const showDetailsHandler = (id) => {
    setDataId(id);
    dispatch(openShowDetailsLeadsDrawer());
  };

  const showChatsHandler = (id) => {
    setDataId(id);
    dispatch(openShowChatDrawer());
  };

  useEffect(() => {
    if (isAllowed) {
      fetchAllLeads();
    }
  }, []);

  useEffect(() => {
    if (location?.state?.searchKey) {
      setSearchKey(location?.state?.searchKey);
    }
  }, []);

  //lead category count
  const calculateLeadCounts = (filteredData) => {
    const counts = {
      hot: 0,
      warm: 0,
      cold: 0,
    };

    // Count the number of leads in each category
    filteredData.forEach((lead) => {
      if (lead.leadCategory === "Hot") {
        counts.hot++;
      } else if (lead.leadCategory === "Warm") {
        counts.warm++;
      } else if (lead.leadCategory === "Cold") {
        counts.cold++;
      }
    });

    return counts;
  };

  const [leadCounts, setLeadCounts] = useState({
    hot: 0,
    warm: 0,
    cold: 0,
  });

  useEffect(() => {
    // Calculate lead counts when filteredData changes
    const counts = calculateLeadCounts(filteredData);
    setLeadCounts(counts);
  }, [filteredData]);

  const chartData = {
    labels: ["Hot", "Warm", "Cold"],
    data: [leadCounts.hot, leadCounts.warm, leadCounts.cold],
    ChartColors: ["#F57D6A", "#F8D76A", "#54CA21"],
  };

  // filter by status

  const calculateLeadStatus = (filteredData) => {
    const counts = {
      FollowUp: 0,
      OnHold: 0,
      Cancelled: 0,
      New: 0,
    };

    filteredData.forEach((lead) => {
      if (lead?.status === "Follow Up") {
        counts.FollowUp++;
      } else if (lead?.status === "On Hold") {
        counts.OnHold++;
      } else if (lead?.status === "Cancelled") {
        counts.Cancelled++;
      } else if (lead?.status === "New") {
        counts.New++;
      }
    });

    return counts;
  };

  const [statusCounts, setStatusCounts] = useState({
    FollowUp: 0,
    OnHold: 0,
    Cancelled: 0,
    New: 0,
  });

  //source graph data
  const calculateLeadSource = (filteredData) => {
    const counts = {
      Linkedin: 0,
      SocialMedia: 0,
      Website: 0,
      Advertising: 0,
      Friend: 0,
      ProfessionalsNetwork: 0,
      CustomerReferral: 0,
      Sales: 0,
      DigitalMarketing: 0,
      Upwork: 0,
      Gem: 0,
      Freelancer: 0,
    };

    filteredData.forEach((lead) => {
      switch (lead?.source) {
        case "Linkedin":
          counts.Linkedin++;
          break;
        case "Social Media":
          counts.SocialMedia++;
          break;
        case "Website":
          counts.Website++;
          break;
        case "Advertising":
          counts.Advertising++;
          break;
        case "Friend":
          counts.Friend++;
          break;
        case "Professionals Network":
          counts.ProfessionalsNetwork++;
          break;
        case "Customer Referral":
          counts.CustomerReferral++;
          break;
        case "Sales":
          counts.Sales++;
          break;
        case "Digital Marketing":
          counts.DigitalMarketing++;
          break;
        case "Upwork":
          counts.Upwork++;
          break;
        case "Gem":
          counts.Gem++;
          break;
        case "Freelancer":
          counts.Freelancer++;
          break;
        case "Linkedin":
          counts.Linkedin++;
          break;
        default:
          // Handle the case where status does not match any of the above
          break;
      }
    });

    return counts;
  };

  const [sourceCounts, setSourceCounts] = useState({
    Linkedin: 0,
    SocialMedia: 0,
    Website: 0,
    Advertising: 0,
    Friend: 0,
    ProfessionalsNetwork: 0,
    CustomerReferral: 0,
    Sales: 0,
    DigitalMarketing: 0,
    Upwork: 0,
    Gem: 0,
    Freelancer: 0,
  });

  useEffect(() => {
    // Calculate lead counts when filteredData changes
    const counts = calculateLeadStatus(filteredData);
    setStatusCounts(counts);

    const sources = calculateLeadSource(filteredData);
    setSourceCounts(sources);
  }, [filteredData]);

  const statusChartData = {
    labels: ["Follow Up", "On Hold", "Cancelled", "New"],
    data: [
      statusCounts.FollowUp,
      statusCounts.OnHold,
      statusCounts.Cancelled,
      statusCounts.New,
    ],
    ChartColors: [
      "#F57D6A",
      "#F8D76A",
      "#54CA21",
      "#21CAC1",
      "#2170CA",
      "#C439EB",
      "#C7C7C7",
      "#F35C9D",
      "#55DCB8",
    ],
  };

  const sourceChartData = {
    labels: [
      "Linkedin",
      "Social Media",
      "Website",
      "Advertising",
      "Friend",
      "Professionals Network",
      "Customer Referral",
      "Sales",
      "DigitalMarketing",
      "Upwork",
      "Gem",
      "Freelancer",
    ],
    data: [
      sourceCounts.Linkedin,
      sourceCounts.SocialMedia,
      sourceCounts.Website,
      sourceCounts.Advertising,
      sourceCounts.Friend,
      sourceCounts.ProfessionalsNetwork,
      sourceCounts.CustomerReferral,
      sourceCounts.Sales,
      sourceCounts.DigitalMarketing,
      sourceCounts.Upwork,
      sourceCounts.Gem,
      sourceCounts.Freelancer,
    ],
    ChartColors: [
      "#F57D6A",
      "#F8D76A",
      "#54CA21",
      "#21CAC1",
      "#2170CA",
      "#C439EB",
      "#C7C7C7",
      "#F35C9D",
      "#55DCB8",
      "#B53471",
      "#5758BB",
      "#EE5A24",
    ],
  };

  useEffect(() => {
    setBulkSMSMobiles([]);
    setIsAllSelected(false);

    let searchedData = data;

    // Apply search key filter
    if (searchKey.trim() !== "") {
      searchedData = data.filter(
        (d) =>
          (d?.leadtype === "People"
            ? "individual".includes(searchKey.toLowerCase())
            : "corporate".includes(searchKey.toLowerCase())) ||
          d?.name?.toLowerCase().includes(searchKey.toLowerCase()) ||
          d?.source?.toLowerCase().includes(searchKey.toLowerCase()) ||
          d?.status?.toLowerCase().includes(searchKey.toLowerCase()) ||
          d?.tag?.toLowerCase().includes(searchKey.toLowerCase()) ||
          d?.assigned?.toLowerCase().includes(searchKey.toLowerCase()) ||
          d?.leadCategory?.toLowerCase().includes(searchKey.toLowerCase()) ||
          d?.phone?.includes(searchKey) ||
          d?.followup_reason?.toLowerCase()?.includes(searchKey) ||
          d?.creator?.toLowerCase()?.includes(searchKey) ||
          (d?.followup_date &&
            new Date(d?.followup_date)
              ?.toISOString()
              ?.substring(0, 10)
              ?.split("-")
              .reverse()
              .join("")
              ?.includes(searchKey.replaceAll("/", ""))) ||
          (d?.createdAt &&
            new Date(d?.createdAt)
              ?.toISOString()
              ?.substring(0, 10)
              ?.split("-")
              .reverse()
              .join("")
              ?.includes(searchKey.replaceAll("/", ""))) ||
          d?.email?.toLowerCase().includes(searchKey.toLowerCase())
      );
    }

    if (startDate || endDate) {
      searchedData = searchedData.filter((d) => {
        const date = new Date(d?.createdAt);
        const formattedDate = date.toISOString().substring(0, 10);

        const isAfterStartDate = startDate ? formattedDate >= startDate : true;
        const isBeforeEndDate = endDate ? formattedDate <= endDate : true;

        return isAfterStartDate && isBeforeEndDate;
      });
    }

    setFilteredData(searchedData);
  }, [searchKey, data, startDate, endDate]);

  useEffect(() => {
    setIsAllSelected(false);
    setBulkSMSMobiles([]);
  }, [pageIndex]);

  function getCategoryColor(category) {
    switch (category?.toLowerCase()) {
      case "hot":
        return "red";
      case "warm":
        return "orange";
      case "cold":
        return "blue";
      default:
        return "gray";
    }
  }

  const handleSelection = (e, id, phone, name) => {
    if (e.target.checked) {
      setDataInfo([...dataInfo, id]);
      // setSelectedUsers([...selectedUsers, { phone, name }]);
    } else {
      const filter = dataInfo.filter((item) => item !== id);
      setDataInfo(filter);
      // setSelectedUsers([]);
    }
  };

  const addtoDataBank = async () => {
    setLoading(true);
    try {
      const response = await fetch(baseURL + "lead/data/bank", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${cookies?.access_token}`,
        },
        credentials: "include",
        body: JSON.stringify({ dataInfo, dataBank: true }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Something went wrong");
      }

      fetchAllLeads();
      toast.success("Data added successfully!");
    } catch (err) {
      toast.error(err.message || "Failed to add data");
    } finally {
      setLoading(false);
    }
  };

  const [selectedGraph, setSelectedGraph] = useState("PieChart");

  const handleGraphChange = (e) => {
    setSelectedGraph(e.target.value);
  };

  // Function to calculate KYC progress percentage
  const calculateKYCProgress = () => {
    if (!filteredData || filteredData.length === 0) {
      return 0;
    }

    const totalFields = 10; // Total number of KYC fields
    let totalFilledFields = 0;

    filteredData.forEach((lead) => {
      let filledFields = 0;

      // Check if name exists (from people or company)
      if (lead.name && lead.name.trim() !== "") {
        filledFields++;
      }

      // Check if phone exists
      if (lead.phone && lead.phone.trim() !== "") {
        filledFields++;
      }

      // Check if email exists
      if (lead.email && lead.email.trim() !== "") {
        filledFields++;
      }

      // Check if status exists
      if (lead.status && lead.status.trim() !== "") {
        filledFields++;
      }

      // Check if source exists
      if (lead.source && lead.source.trim() !== "") {
        filledFields++;
      }

      // Check if assigned exists
      if (lead.assigned && lead.assigned.trim() !== "") {
        filledFields++;
      }

      // Check if notes exists
      if (lead.notes && lead.notes.trim() !== "") {
        filledFields++;
      }

      // Check if PRC QT exists
      if (lead.prc_qt && lead.prc_qt.trim() !== "") {
        filledFields++;
      }

      // Check if location exists
      if (lead.location && lead.location.trim() !== "") {
        filledFields++;
      }

      // Check if lead category exists
      if (lead.leadCategory && lead.leadCategory.trim() !== "") {
        filledFields++;
      }

      totalFilledFields += filledFields;
    });

    // Calculate average percentage across all leads
    const averagePercentage = Math.round(
      (totalFilledFields / (filteredData.length * totalFields)) * 100
    );
    return averagePercentage;
  };

  const whatsappHandler = async (e) => {
    e.preventDefault();
    //  console.log(selectedUsers);
    if (selectedUsers.length === 0) {
      toast.error("Please select users first!");
    } else {
      // Show toastify message instead of opening modal
      toast.info("Kindly contact to customer care");
      // setComponents([{ type: "text", text: "" }]);
      // setTemplateName("");
      // setOpen(true);
    }
  };
  const handleComponentChange = (index, value) => {
    setComponents((prevComponents) =>
      prevComponents.map((component, i) =>
        i === index ? { ...component, text: value } : component
      )
    );
  };
  const handleSaveTemplate = async () => {
    if (!templateId || isNaN(templateId) || !templateText) {
      toast.error(
        "TemplateID must be numeric and both TemplateID and Text are required."
      );
      return;
    }

    setSavingTemplate(true);
    try {
      const response = await fetch(baseURL + "sms/template", {
        // Adjust endpoint to your actual backend route for adding templates
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${cookies?.access_token}`,
        },
        body: JSON.stringify({
          entityId,
          templateName,
          templateId,
          templateText,
        }),
      });

      const data = await response.json();
      if (!data.success) {
        throw new Error(data.message || "Failed to add template");
      }

      toast.success("Template added successfully");
      closeTemplateModal();
      // Reset fields
      setEntityId("");
      setTemplateName("");
      setTemplateId("");
      setTemplateText("");
      // Optionally: Fetch and refresh a list of templates if you add a table below the form
    } catch (err) {
      toast.error(err.message);
    } finally {
      setSavingTemplate(false);
    }
  };

  const addComponent = () => {
    setComponents((prevComponents) => [
      ...prevComponents,
      { type: "text", text: "" },
    ]);
  };

  const sendMessages = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      for (const data of selectedUsers) {
        const finalComponents = components.map((comp, index) =>
          index === 0 ? { type: "text", text: data.name } : comp.text && comp
        );
        const payload = {
          phone: data.phone.trim(),
          template_name: templateName,
          template_lang: templateLang,
          components: finalComponents,
        };

        const res = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}send-builk-Whatsapp/`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${cookies?.access_token}`,
            },
          }
        );
      }

      toast.success("Messages sent successfully!");
    } catch (error) {
      console.log(error);
      toast.error(`Error while sending message: ${error}`);
    } finally {
      // Uncheck all checkboxes
      const checkboxes = document.querySelectorAll('input[name="select"]');
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });

      // Reset states
      setSelectedUsers([]);
      setIsAllSelected(false);
      setOpen(false);
      setLoading(false);
    }
  };

  const fetchTemplate = async () => {
    console.log("hey");
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}whatsapp/templates`
      );
      setTemData(res?.data?.data);
      console.log("temData", res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTemplate();
  }, []);

  return (
    <>
      {!isAllowed && (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-3xl font-bold text-[#ff6f6f] flex gap-x-2">
          {msg}
        </div>
      )}

      {isAllowed && (
        <div>
          <>
            <AlertDialog
              isOpen={isOpen}
              leastDestructiveRef={cancelRef}
              onClose={onClose}
            >
              <AlertDialogOverlay>
                <AlertDialogContent>
                  <AlertDialogHeader fontSize="lg" fontWeight="bold">
                    {!deleteAll && leadDeleteId && <span>Delete Lead</span>}
                    {deleteAll && !leadDeleteId && (
                      <span>Delete All Leads</span>
                    )}
                  </AlertDialogHeader>

                  <AlertDialogBody>
                    Are you sure, deleting a Lead will also delete its
                    corresponding Offers?
                  </AlertDialogBody>

                  <AlertDialogFooter>
                    <Button ref={cancelRef} onClick={onClose}>
                      Cancel
                    </Button>
                    {!deleteAll && leadDeleteId && (
                      <Button colorScheme="red" onClick={deleteHandler} ml={3}>
                        Delete Lead
                      </Button>
                    )}
                    {deleteAll && !leadDeleteId && (
                      <Button
                        colorScheme="red"
                        onClick={deleteAllHandler}
                        ml={3}
                      >
                        Delete All
                      </Button>
                    )}
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialogOverlay>
            </AlertDialog>
          </>
          <div>
            <div className="flex flex-col items-start justify-start gap-y-1 md:justify-between mb-4  pb-2 z-10">
              <div className="w-full flex text-lg lg:text-xl justify-between font-semibold lg:items-center gap-y-1 mb-2">
                {/* <span className="mr-2">
                  <MdArrowBack />
                </span> */}
                <div>Lead List</div>
                <div className="flex gap-x-2">
                  <textarea
                    className="rounded-[10px] w-full md:flex-1 px-2 py-2 md:px-3 md:py-2 text-sm focus:outline-[#1640d6] hover:outline:[#1640d6] border resize-none"
                    rows="1"
                    width="220px"
                    placeholder="Search"
                    value={searchKey}
                    onChange={(e) => setSearchKey(e.target.value)}
                  />
                  <Button
                    fontSize={{ base: "14px", md: "14px" }}
                    paddingX={{ base: "10px", md: "12px" }}
                    paddingY={{ base: "0", md: "3px" }}
                    width={{ base: "-webkit-fill-available", md: 100 }}
                    onClick={() => {
                      fetchAllLeads();
                      fetchLeadSummary();
                    }}
                    leftIcon={<MdOutlineRefresh />}
                    color="#1640d6"
                    borderColor="#1640d6"
                    variant="outline"
                  >
                    Refresh
                  </Button>
                </div>
              </div>

              <div className="mt-3 md:mt-0 flex flex-wrap justify-start gap-3 w-full">
                {/* Add New Lead */}
                <Button
                  fontSize={{ base: "13px", md: "14px" }}
                  px={{ base: "5px", md: "10px" }}
                  py={{ base: "6px", md: "8px" }}
                  w={{ base: "100%", md: "auto" }}
                  colorScheme="blue"
                  variant="solid"
                  boxShadow="sm"
                  _hover={{ transform: "translateY(-1px)", boxShadow: "md" }}
                  onClick={addLeadsHandler}
                >
                  Add New Lead
                </Button>

                {/* Bulk buttons (visible only when 2 or more selected) */}
                {selectedUsers.length >= 1 && (
                  <>
                    <Button
                      fontSize={{ base: "13px", md: "14px" }}
                      px={{ base: "5px", md: "10px" }}
                      py={{ base: "6px", md: "8px" }}
                      w={{ base: "100%", md: "auto" }}
                      colorScheme="yellow"
                      variant="solid"
                      boxShadow="sm"
                      _hover={{
                        transform: "translateY(-1px)",
                        boxShadow: "md",
                      }}
                      onClick={bulkSMSHandler}
                    >
                      Bulk SMS
                    </Button>

                    <Button
                      fontSize={{ base: "13px", md: "14px" }}
                      px={{ base: "5px", md: "10px" }}
                      py={{ base: "6px", md: "8px" }}
                      w={{ base: "100%", md: "auto" }}
                      colorScheme="whatsapp"
                      variant="solid"
                      boxShadow="sm"
                      _hover={{
                        transform: "translateY(-1px)",
                        boxShadow: "md",
                      }}
                      onClick={whatsappHandler}
                    >
                      Bulk WhatsApp
                    </Button>

                    <Button
                      fontSize={{ base: "13px", md: "14px" }}
                      px={{ base: "5px", md: "10px" }}
                      py={{ base: "6px", md: "8px" }}
                      w={{ base: "100%", md: "auto" }}
                      colorScheme="orange"
                      variant="solid"
                      boxShadow="sm"
                      _hover={{
                        transform: "translateY(-1px)",
                        boxShadow: "md",
                      }}
                      onClick={bulkAssignHandler}
                    >
                      Bulk Assign
                    </Button>

                    {role === "Super Admin" && (
                      <Button
                        fontSize={{ base: "13px", md: "14px" }}
                        px={{ base: "5px", md: "10px" }}
                        py={{ base: "6px", md: "8px" }}
                        w={{ base: "100%", md: "auto" }}
                        colorScheme="teal"
                        variant="solid"
                        boxShadow="sm"
                        _hover={{
                          transform: "translateY(-1px)",
                          boxShadow: "md",
                        }}
                        onClick={bulkDownloadHandler}
                      >
                        Bulk Download
                      </Button>
                    )}

                    {/* Bulk Upload */}
                    <div className="w-full md:w-auto">
                      <Button
                        fontSize={{ base: "13px", md: "14px" }}
                        px={{ base: "5px", md: "10px" }}
                        py={{ base: "6px", md: "8px" }}
                        w={{ base: "100%", md: "auto" }}
                        colorScheme="cyan"
                        variant="solid"
                        boxShadow="sm"
                        _hover={{
                          transform: "translateY(-1px)",
                          boxShadow: "md",
                        }}
                        onClick={() => setToggleBulkUpload((prev) => !prev)}
                      >
                        Bulk Upload
                      </Button>

                      {toggleBulkUpload && (
                        <div className="mt-2 space-y-2">
                          <a href={sampleCSV}>
                            <Button
                              w={{ base: "100%", md: "200px" }}
                              variant="outline"
                              colorScheme="blue"
                              _hover={{ bg: "blue.50" }}
                            >
                              Download Sample CSV
                            </Button>
                          </a>

                          <form
                            onSubmit={bulkUploadHandler}
                            className="flex flex-col gap-2"
                          >
                            <input
                              ref={csvRef}
                              className="border border-gray-300 rounded-md p-2 text-sm focus:outline-blue-500"
                              type="file"
                              accept=".csv"
                            />
                            <Button
                              isDisabled={bulkUploading}
                              isLoading={bulkUploading}
                              colorScheme="blue"
                              type="submit"
                              boxShadow="sm"
                            >
                              Upload
                            </Button>
                          </form>
                        </div>
                      )}
                    </div>
                  </>
                )}

                {/* Add to Archive */}
                <Button
                  fontSize={{ base: "13px", md: "14px" }}
                  px={{ base: "10px", md: "14px" }}
                  py={{ base: "6px", md: "8px" }}
                  w={{ base: "100%", md: "auto" }}
                  colorScheme="gray"
                  variant="solid"
                  boxShadow="sm"
                  _hover={{ transform: "translateY(-1px)", boxShadow: "md" }}
                  onClick={addtoDataBank}
                >
                  Add to Archive
                </Button>

                {/* Add SMS Template */}
                <Button
                  fontSize={{ base: "13px", md: "14px" }}
                  px={{ base: "5px", md: "14px" }}
                  py={{ base: "6px", md: "8px" }}
                  w={{ base: "100%", md: "auto" }}
                  colorScheme="pink"
                  variant="solid"
                  boxShadow="sm"
                  _hover={{ transform: "translateY(-1px)", boxShadow: "md" }}
                  onClick={openTemplateModal}
                >
                  Add SMS Template
                </Button>

                {/* Page size select */}
                <Select
                  onChange={(e) => setPageSize(Number(e.target.value))}
                  value={pageSize}
                  width="80px"
                  borderColor="gray.300"
                  borderRadius="md"
                  fontSize="14px"
                  _hover={{ borderColor: "blue.400" }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={100000}>All</option>
                </Select>

                <div className="flex items-center gap-2">
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="p-2 border border-gray-300 rounded-md text-sm focus:border-blue-400 focus:outline-none"
                  />
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="p-2 border border-gray-300 rounded-md text-sm focus:border-blue-400 focus:outline-none"
                  />
                </div>
              </div>
            </div>

            {!loading && filteredData.length > 0 && (
              <div className="flex justify-end gap-x-2 mb-4">
                <button
                  onClick={() => setViewMode("table")}
                  className={`p-2 rounded-md transition-colors duration-200 ${viewMode === "table"
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-600 hover:bg-gray-300"
                    }`}
                  title="Table View"
                >
                  <BiTable size={20} />
                </button>
                <button
                  onClick={() => setViewMode("card")}
                  className={`p-2 rounded-md transition-colors duration-200 ${viewMode === "card"
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-600 hover:bg-gray-300"
                    }`}
                  title="Card View"
                >
                  <BiCard size={20} />
                </button>
              </div>
            )}


            <div>
              {showChatDrawerIsOpened && (
                <ClickMenu
                  top={0}
                  right={0}
                  closeContextMenuHandler={() =>
                    dispatch(closeShowChatDrawer())
                  }
                >
                  <Chatdrawer
                    dataId={dataId}
                    closeDrawerHandler={() => dispatch(closeShowChatDrawer())}
                  />
                </ClickMenu>
              )}

              <HStack className="">
                {kycDrawerIsOpened && (
                  <ClickMenu
                    top={0}
                    right={0}
                    closeContextMenuHandler={() => dispatch(closeKYCDrawer())}
                  >
                    <KYCDrawer
                      closeDrawerHandler={() => dispatch(closeKYCDrawer())}
                      kycProgress={calculateKYCProgress()}
                      totalLeads={filteredData.length}
                      dataId={dataId}
                    />
                  </ClickMenu>
                )}

                {moveToDemoDrawerIsOpened && (
                  <ClickMenu
                    top={0}
                    right={0}
                    closeContextMenuHandler={() =>
                      dispatch(closeMoveToDemoDrawer())
                    }
                  >
                    <MoveToDemo
                      dataId={dataId}
                      fetchAllLeads={fetchAllLeads}
                      closeDrawerHandler={() =>
                        dispatch(closeMoveToDemoDrawer())
                      }
                      leadData={data.find((lead) => lead._id === dataId)}
                    />
                  </ClickMenu>
                )}

                {showBulkAssignDrawerIsOpened && (
                  <ClickMenu
                    top={0}
                    right={0}
                    closeContextMenuHandler={() =>
                      dispatch(closeShowBulkAssignDrawer())
                    }
                  >
                    <BulkAssignDrawer
                      leads={selected}
                      fetchAllLeads={fetchAllLeads}
                      fetchLeadSummary={fetchLeadSummary}
                      closeDrawerHandler={() =>
                        dispatch(closeShowBulkAssignDrawer())
                      }
                      data={[]}
                    />
                  </ClickMenu>
                )}

                {sendSMSDrawerIsOpened && (
                  <ClickMenu
                    top={0}
                    right={0}
                    closeContextMenuHandler={() => {
                      dispatch(closeSendSMSDrawer());
                      // setBulkSMSMobiles([]);
                      // setBulkName([]);
                    }}
                    leads={selected}
                  >
                    <SMSDrawer
                      fetchAllLeads={fetchAllLeads}
                      closeDrawerHandler={() => {
                        dispatch(closeSendSMSDrawer());
                        // setBulkSMSMobiles([]);
                        // setBulkName([]);
                      }}
                      mobiles={bulkSMSMobiles}
                      names={bulkName}
                      leads={selected}
                    />
                  </ClickMenu>
                )}

                {addLeadsDrawerIsOpened && (
                  <ClickMenu
                    top={0}
                    right={0}
                    closeContextMenuHandler={() =>
                      dispatch(closeAddLeadsDrawer())
                    }
                  >
                    <LeadsDrawer
                      fetchLeadSummary={fetchLeadSummary}
                      fetchAllLeads={fetchAllLeads}
                      closeDrawerHandler={() => dispatch(closeAddLeadsDrawer())}
                      onOpenMoveToDemo={(id) => {
                        setDataId(id);
                        dispatch(openMoveToDemoDrawer());
                      }}
                    />
                  </ClickMenu>
                )}

                {editLeadsDrawerIsOpened && (
                  <ClickMenu
                    top={0}
                    right={0}
                    closeContextMenuHandler={() =>
                      dispatch(closeEditLeadsDrawer())
                    }
                  >
                    <LeadEditDrawer
                      dataId={dataId}
                      fetchAllLeads={fetchAllLeads}
                      onOpenMoveToDemo={(id) => {
                        setDataId(id);
                        dispatch(openMoveToDemoDrawer());
                      }}
                      closeDrawerHandler={() =>
                        dispatch(closeEditLeadsDrawer())
                      }
                    />
                  </ClickMenu>
                )}

                {showDetailsLeadsDrawerIsOpened && (
                  <ClickMenu
                    top={0}
                    right={0}
                    closeContextMenuHandler={() =>
                      dispatch(closeShowDetailsLeadsDrawer())
                    }
                  >
                    <LeadsDetailsDrawer
                      dataId={dataId}
                      closeDrawerHandler={() =>
                        dispatch(closeShowDetailsLeadsDrawer())
                      }
                    />
                  </ClickMenu>
                )}
              </HStack>

              {loading && (
                <div>
                  <Loading />
                </div>
              )}
              {!loading && filteredData.length === 0 && (
                <div className="flex items-center justify-center flex-col">
                  <FcDatabase color="red" size={80} />
                  <span className="mt-1 font-semibold text-2xl">
                    No data found.
                  </span>
                </div>
              )}

              {viewMode === "card" && !loading && filteredData.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

                  {filteredData.map((item) => (
                    <div
                      key={item._id}
                      className="border rounded-lg p-4 bg-white shadow-md hover:shadow-lg transition-shadow duration-300"
                    >
                      {/* Header Section */}
                      <div className="flex justify-between items-start mb-3">
                        <div className="bg-yellow-500 text-yellow-800 text-center rounded-md px-3 py-1 text-sm font-semibold">
                          {item.leadtype || "N/A"}
                        </div>

                        <div className="flex flex-col items-end gap-1">
                          {item.status && (
                            <div
                              className="text-center rounded-md px-3 py-1 text-sm font-semibold"
                              style={{
                                backgroundColor:
                                  statusStyles[String(item.status || '').toLowerCase()]?.bg,
                                color: statusStyles[String(item.status || '').toLowerCase()]?.text,
                              }}
                            >
                              {item.status}
                            </div>
                          )}
                          {item.tag && (
                            <Badge colorScheme="purple" className="text-xs px-2 py-1 rounded">
                              Tag: {item.tag}
                            </Badge>
                          )}
                        </div>
                      </div>

                      {/* Body Section */}
                      <div className="space-y-2 mb-4">
                        <div className="font-semibold text-lg text-gray-800">
                          {item.name}
                        </div>

                        <div className="text-gray-600">
                          <span className="font-medium">Created:</span>{" "}
                          {moment(item.createdAt).format("DD/MM/YYYY")}
                        </div>

                        <div className="text-gray-600">
                          <span className="font-medium">Source:</span>{" "}
                          {item.source || "N/A"}
                        </div>

                        <div className="text-gray-600">
                          <span className="font-medium">Assigned:</span>{" "}
                          {item.assigned || "Not Assigned"}
                        </div>

                        {item.followup_date && (
                          <div className="text-gray-600">
                            <span className="font-medium">Follow Up:</span>{" "}
                            {moment(item.followup_date).format("DD/MM/YYYY")}
                          </div>
                        )}

                        {item.followup_reason && (
                          <div className="text-gray-600">
                            <span className="font-medium">Reason:</span>{" "}
                            {item.followup_reason.substr(0, 20)}...
                          </div>
                        )}

                        {item.leadCategory && (
                          <div className="bg-blue-100 text-blue-800 text-center rounded-md py-1 text-sm">
                            <span className="font-medium">Category:</span>{" "}
                            {item.leadCategory}
                          </div>
                        )}
                      </div>

                      {/* Action Buttons */}
                      <div className="flex justify-center space-x-10 border-t pt-3 mt-4">
                        <FaCalendarAlt
                          className="text-blue-500 hover:scale-110 cursor-pointer"
                          size={20}
                          title="Schedule Meeting"
                          onClick={() => {
                            setDataId(item._id);
                            dispatch(openMoveToDemoDrawer());
                          }}
                        />
                        <MdOutlineVisibility
                          size={20}
                          className="text-blue-500 hover:scale-110 cursor-pointer"
                          onClick={() => showDetailsHandler(item._id)}
                        />
                        <MdEdit
                          size={20}
                          className="text-yellow-500 hover:scale-110 cursor-pointer"
                          onClick={() => editHandler(item._id)}
                        />
                        <MdDeleteOutline
                          size={20}
                          className="text-red-500 hover:scale-110 cursor-pointer"
                          onClick={() => {
                            setLeadDeleteId(item._id);
                            confirmDeleteHandler();
                          }}
                        />
                      </div>
                    </div>
                  ))}

                </div>
              )}





              {viewMode === "table" && !loading && filteredData.length > 0 && (
                <div>
                  <TableContainer
                    maxHeight="600px"
                    overflowY="auto"
                    className="shadow-lg rounded-lg bg-white"
                  >
                    <Table
                      {...getTableProps()}
                      borderWidth="1px"
                      borderColor="#e0e0e0"
                      className="min-w-full"
                    >
                      <Thead
                        position="sticky"
                        top={0}
                        zIndex={1}
                        bg="blue.400"
                        color="white"
                        boxShadow="0px 4px 6px rgba(0, 0, 0, 0.1)"
                        className="text-lg font-semibold"
                      >
                        {headerGroups.map((hg) => {
                          return (
                            <Tr {...hg.getHeaderGroupProps()}>
                              {hg.headers.map((column) => {
                                return (
                                  <Th
                                    bg="blue.400"
                                    className={`${column.id === "name"
                                      ? "sticky top-0 left-[-2px]"
                                      : ""
                                      }`}
                                    {...column.getHeaderProps(
                                      column.getSortByToggleProps()
                                    )}
                                    textTransform="capitalize"
                                    fontSize="15px"
                                    fontWeight="700"
                                    color="white"
                                  >
                                    <div className="flex items-center">
                                      {column.render("Header")}
                                      {column.isSorted && (
                                        <span>
                                          {column.isSortedDesc ? (
                                            <FaCaretDown />
                                          ) : (
                                            <FaCaretUp />
                                          )}
                                        </span>
                                      )}
                                    </div>
                                  </Th>
                                );
                              })}
                              <Th
                                textTransform="capitalize"
                                fontSize="15px"
                                fontWeight="700"
                                color="white"
                                borderLeft="1px solid #e0e0e0"
                                borderRight="1px solid #e0e0e0"
                              >
                                Actions
                              </Th>
                            </Tr>
                          );
                        })}
                      </Thead>

                      <Tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Tr
                              className="relative hover:bg-gray-100 cursor-pointer text-base lg:text-base"
                              {...row.getRowProps()}
                            >
                              {row.cells.map((cell) => {
                                return (
                                  <Td
                                    className={
                                      cell.column.id === "name"
                                        ? "sticky left-0 bg-gray-50 hover:bg-gray-100"
                                        : ""
                                    }
                                    fontWeight="600"
                                    padding="16px"
                                    {...cell.getCellProps()}
                                  >
                                    {/* DEFAULT CELLS */}
                                    {cell.column.id !== "select" &&
                                      cell.column.id !== "leadtype" &&
                                      cell.column.id !== "status" &&
                                      cell.column.id !== "source" &&
                                      cell.column.id !== "assigned" &&
                                      cell.column.id !== "followup_date" &&
                                      cell.column.id !== "followup_reason" &&
                                      cell.column.id !== "created_on" &&
                                      cell.column.id !== "leadCategory" &&
                                      cell.column.id !== "tag" &&
                                      cell.render("Cell")}

                                    {/* SELECT CHECKBOX */}
                                    {cell.column.id === "select" && (
                                      <input
                                        value={cell.row.original._id}
                                        name="select"
                                        type="checkbox"
                                        className="cursor-pointer"
                                        checked={selectedIds.includes(
                                          cell.row.original._id
                                        )}
                                        onChange={(e) =>
                                          selectOneHandler(
                                            e,
                                            cell.row.original._id
                                          )
                                        }
                                      />
                                    )}

                                    {/* LEAD TYPE */}
                                    {cell.column.id === "leadtype" && (
                                      <span
                                        className={`text-sm rounded-md px-3 py-1 ${row.original.leadtype === "People"
                                            ? "bg-[#fff0f6] text-[#c41d7f]"
                                            : "bg-[#e6f4ff] text-[#0958d9]"
                                          }`}
                                      >
                                        {row.original.leadtype === "People"
                                          ? "Individual"
                                          : "Corporate"}
                                      </span>
                                    )}

                                    {/* CREATED DATE */}
                                    {cell.column.id === "created_on" &&
                                      row.original?.createdAt && (
                                        <span>
                                          {moment(
                                            row.original?.createdAt
                                          ).format("DD/MM/YYYY")}
                                        </span>
                                      )}

                                    {/* FOLLOWUP DATE */}
                                    {cell.column.id === "followup_date" &&
                                      row.original?.followup_date && (
                                        <span>
                                          {moment(
                                            row.original?.followup_date
                                          ).format("DD/MM/YYYY")}
                                        </span>
                                      )}

                                    {/* FOLLOW UP REASON */}
                                    {cell.column.id === "followup_reason" &&
                                      row.original?.followup_reason && (
                                        <span>
                                          {row.original?.followup_reason?.substr(
                                            0,
                                            10
                                          )}
                                          ...
                                        </span>
                                      )}

                                    {/* STATUS */}
                                    {cell.column.id === "status" && (
                                      <span
                                        className="text-sm rounded-md px-3 py-1"
                                        style={{
                                          backgroundColor:
                                            statusStyles[
                                              String(row.original?.status || '').toLowerCase()
                                            ]?.bg,
                                          color:
                                            statusStyles[
                                              String(row.original?.status || '').toLowerCase()
                                            ]?.text,
                                        }}
                                      >
                                        {row.original.status}
                                      </span>
                                    )}

                                    {/* SOURCE */}
                                    {cell.column.id === "source" && (
                                      <span
                                        className="text-sm rounded-md px-3 py-1"
                                        style={{
                                          backgroundColor:
                                            sourceStyles[
                                              String(row?.original?.source || '').toLowerCase()
                                            ]?.bg,
                                          color:
                                            sourceStyles[
                                              String(row?.original?.source || '').toLowerCase()
                                            ]?.text,
                                        }}
                                      >
                                        {row.original.source}
                                      </span>
                                    )}

                                    {/* ASSIGNED */}
                                    {cell.column.id === "assigned" && (
                                      <span>
                                        {row.original?.assigned || "Not Assigned"}
                                      </span>
                                    )}

                                    {/* LEAD CATEGORY */}
                                    {cell.column.id === "leadCategory" && (
                                      <Badge
                                        className="text-sm rounded-md px-3 py-1"
                                        colorScheme={getCategoryColor(
                                          row.original?.leadCategory
                                        )}
                                      >
                                        {row.original?.leadCategory}
                                      </Badge>
                                    )}

                                    {/* TAG */}
                                    {cell.column.id === "tag" && (
                                      <Badge
                                        className="text-sm rounded-md px-3 py-1"
                                        colorScheme="purple"
                                      >
                                        {row.original?.tag || "N/A"}
                                      </Badge>
                                    )}
                                  </Td>
                                );
                              })}

                              {/* ROW ACTIONS */}
                              <Td className="flex items-center gap-x-3">
                                <FaCalendarAlt
                                  className="text-blue-500 hover:scale-110 transition-transform cursor-pointer"
                                  size={20}
                                  title="Schedule Meeting"
                                  onClick={() => {
                                    setDataId(row.original?._id);
                                    dispatch(openMoveToDemoDrawer());
                                  }}
                                />

                                <Menu>
                                  <MenuButton
                                    as={IconButton}
                                    icon={<MdMoreVert />}
                                    variant="ghost"
                                    size="sm"
                                    className="hover:bg-gray-100"
                                  />
                                  <Portal>
                                    <MenuList>
                                      <MenuItem
                                        icon={<MdOutlineVisibility />}
                                        onClick={() =>
                                          showDetailsHandler(row.original?._id)
                                        }
                                      >
                                        View
                                      </MenuItem>
                                      <MenuItem
                                        icon={<MdEdit />}
                                        onClick={() =>
                                          editHandler(row.original?._id)
                                        }
                                      >
                                        Edit
                                      </MenuItem>
                                      <MenuItem
                                        icon={<MdDeleteOutline />}
                                        onClick={() => {
                                          setLeadDeleteId(row.original?._id);
                                          confirmDeleteHandler();
                                        }}
                                      >
                                        Delete
                                      </MenuItem>
                                    </MenuList>
                                  </Portal>
                                </Menu>
                              </Td>
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  </TableContainer>

                  {/* PAGINATION */}
                  <div className="w-[max-content] m-auto mt-4 mb-6">
                    <button
                      className="text-sm mt-2 bg-[#1640d6] py-1 px-4 text-white rounded-3xl disabled:bg-gray-400 disabled:cursor-not-allowed md:text-lg"
                      disabled={!canPreviousPage}
                      onClick={previousPage}
                    >
                      Prev
                    </button>

                    <span className="mx-3 text-sm md:text-lg">
                      {pageIndex + 1} of {pageCount}
                    </span>

                    <button
                      className="text-sm mt-2 bg-[#1640d6] py-1 px-4 text-white rounded-3xl disabled:bg-gray-400 disabled:cursor-not-allowed md:text-lg"
                      disabled={!canNextPage}
                      onClick={nextPage}
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}

            </div>
          </div>
          <div className="w-full mx-auto mt-3">
            <h1 className="text-lg md:text-xl font-semibold">Leads Summary</h1>

            {/* Dropdown to select graph type */}
            <div className="mt-2">
              <Select
                value={selectedGraph}
                onChange={handleGraphChange}
                className="p-2 border border-gray-300 rounded-md"
              >
                <option value="PieChart">Lead Status</option>
                <option value="anotherGraph">Lead Category</option>
                <option value="sourceGraph">Lead Source</option>
                {/* Add more options as needed */}
              </Select>
            </div>

            {!loading && statusChartData && (
              <div className="mx-auto mt-2  w-full p-10">
                {selectedGraph === "PieChart" && (
                  <PieChart
                    labels={statusChartData.labels}
                    data={statusChartData.data}
                    ChartColors={statusChartData.ChartColors}
                  />
                )}

                {selectedGraph === "anotherGraph" && (
                  <PieChart
                    labels={chartData.labels}
                    data={chartData.data}
                    ChartColors={chartData.ChartColors}
                  />
                )}

                {selectedGraph === "sourceGraph" && (
                  <PieChart
                    labels={sourceChartData.labels}
                    data={sourceChartData.data}
                    ChartColors={sourceChartData.ChartColors}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Bulk WhatsApp Modal - Commented out as per requirement */}
      {/* <Modal isOpen={open} onClose={() => setOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Bulk WhatsApp Sender</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <select
              value={templateName}
              onChange={(e) => {
                const selectedName = e.target.value;
                setTemplateName(selectedName);

                const selectedTemplate = temData?.find(
                  (t) => t.name === selectedName
                );

                if (selectedTemplate) {
                  setTemplateLang(selectedTemplate.language || "");
                } else {
                  setTemplateLang("");
                }
              }}
              className="w-full px-4 py-2 mb-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:bg-white transition-all duration-200"
            >
              <option value="">Select Template</option>
              {temData?.map((t, index) => (
                <option key={index} value={t?.name}>
                  {t?.name}
                </option>
              ))}
            </select>

            <Input
              placeholder="Template Language"
              value={templateLang}
              onChange={(e) => setTemplateLang(e.target.value)}
              mb={2}
            />

            {components.slice(1).map((component, index) => (
              <Input
                key={index + 1}
                placeholder={`Component Text ${index + 1}`}
                value={component.text}
                onChange={(e) =>
                  handleComponentChange(index + 1, e.target.value)
                }
                mb={2}
              />
            ))}
            <Box className="flex items-center justify-center gap-2">
              <Button
                onClick={(e) => {
                  e.preventDefault(), addComponent;
                }}
                colorScheme="orange"
              >
                Add Component
              </Button>
              <Button
                onClick={(e) => sendMessages(e)}
                isLoading={loading}
                colorScheme="blue"
              >
                {loading ? "Sending..." : "Send Messages"}
              </Button>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal> */}
      <Modal isOpen={isTemplateModalOpen} onClose={closeTemplateModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Manage Template</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box bg="red.100" color="red.700" p={3} mb={4} borderRadius="md">
              Create in Nimbus Dashboard first (Manage Templates), get verified,
              then enter EXACT details here. Use ( #var# ) for placeholders.
            </Box>

            <Input
              placeholder="Entity ID (from Nimbus, e.g., 1001558230000012624)"
              value={entityId}
              onChange={(e) => setEntityId(e.target.value)}
              mb={4}
            />

            <Input
              placeholder="Template Name (e.g., Welcome Message)"
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              mb={4}
            />

            <Input
              placeholder="Template ID (Numeric from Nimbus, e.g., 17071716548492)"
              type="text" // String for long IDs
              value={templateId}
              onChange={(e) => setTemplateId(e.target.value)}
              mb={4}
            />

            <Textarea
              placeholder="Enter Template Text (Exact from Nimbus, e.g., Dear ( #var# ), Welcome...)"
              value={templateText}
              onChange={(e) => setTemplateText(e.target.value)}
              mb={4}
              rows={4}
            />
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={handleSaveTemplate}
              isLoading={savingTemplate}
            >
              Save
            </Button>
            <Button onClick={closeTemplateModal}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default Leads;
